import { createContext, useContext } from 'react';
import type { Key } from 'react-aria-components';

import { DataTableCellActions } from '../DataTableCellActions';
import type { DataTableAction } from '../types';

export type OpenCellActions = { rowId: Key; columnId: string; anchor?: Element };

type OpenCellActionsState = {
  openCellActions: OpenCellActions | undefined;
  setOpenCellActions: (next: OpenCellActions | undefined) => void;
};

export const DataTableOpenCellActionsContext = createContext<OpenCellActionsState>({
  openCellActions: undefined,
  setOpenCellActions: () => {},
});

type Props<T> = {
  actions: Array<DataTableAction<T>>;
  row: T;
  rowId: Key;
  rowLabel: string;
  columnId: string;
};

export function DataTableRowActions<T>({ actions, row, rowId, rowLabel, columnId }: Props<T>) {
  const { openCellActions, setOpenCellActions } = useContext(DataTableOpenCellActionsContext);

  return (
    <DataTableCellActions
      actions={actions}
      row={row}
      rowLabel={rowLabel}
      isOpen={openCellActions?.rowId === rowId && openCellActions.columnId === columnId}
      onOpenChange={(isOpen) => setOpenCellActions(isOpen ? { rowId, columnId } : undefined)}
    />
  );
}
